
import { BasicDialogHandler } from "@goodgamestudios/core";
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2RegisterBonusDialog } from "../../../view/dialogs/registration/Poker2RegisterBonusDialog";
import { Poker2RegisterBonusDialogProperties } from "../../../view/dialogs/registration/Poker2RegisterBonusDialogProperties";
import { Poker2Command } from "../Poker2Command";

export class BEXCommand extends Poker2Command {
    protected get cmdId(): string {
        return SFConstants.S2C_BONUS_EVENT_XP;
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            Poker2Model.sessionData.specialOffer_XP = paramObj.xp;
            Poker2Model.sessionData.specialOffer_XP_timeleft = paramObj.timeleft;
            Poker2Model.sessionData.activeSpecialOfferXP = true;
            BasicDialogHandler.getInstance().registerDialogs("Poker2RegisterBonusDialog", new Poker2RegisterBonusDialogProperties(paramObj.xp, paramObj.timeleft, paramObj.event), true, BasicDialogHandler.PRIORITY_MIDDLE);

            this.controller.dispatchEvent(new Poker2UserEvent("xpbonus", [paramObj.xp, paramObj.timeleft]));
        }
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
